const LOGO = String.raw`
_    _       _             ___           _  ___  ___    
| |  <_> _ _ <_>._ _  ___  |_ _|___  _ _ <_>| | '| | '___
| |_ | || | || || ' |/ . |  | |<_> || '_>| || |- | |-<_-<
|___||_||__/ |_||_|_|\_. |  |_|<___||_|  |_||_|  |_| /__/
                     <___' 
`;

function logLogo() {
    console.log(LOGO);
}

function logBuildInfo(rows) {
    const labelWidth = 20; // Adjust this to the desired label column width
    const valueWidth = 30; // Adjust this to the desired value column width

    // Function to create a cell with left alignment and padding on the left side
    function createCellLeftAlign(text, width, paddingLeft = 1) {
        return (
            ' '.repeat(paddingLeft) +
            text.padEnd(width - paddingLeft).substring(paddingLeft - 1)
        );
    }

    function drawRow(label, value) {
        console.log(
            `║${createCellLeftAlign(label, labelWidth)}║${createCellLeftAlign(
                value,
                valueWidth
            )}║`
        );
    }

    console.log(`╔${'═'.repeat(labelWidth)}╦${'═'.repeat(valueWidth)}╗`);

    rows.forEach((row, index) => {
        if (index > 0) {
            console.log(
                `╠${'═'.repeat(labelWidth)}╬${'═'.repeat(valueWidth)}╣`
            );
        }
        console.log('row', row);

        if (row.value) {
            drawRow(row.label, row.value);
        } else {
            console.error('Missing row.value for ', row);
        }
    });

    console.log(`╚${'═'.repeat(labelWidth)}╩${'═'.repeat(valueWidth)}╝`);
}

// Export the functions as part of an object
export default {
    logBuildInfo,
    logLogo,
};
